import { UtilisateurTypeCode } from 'src/app/data/intervenant/models/enums/type-utilisateur.enum';
import { ArrayClassConverterFactory } from '../../core/services/mapper/data-property.converter';

export class ApiCredentials {
    static jsonMap = {
        token: { key: 'token' },
        idOrganisme: { key: 'idOrganisme', optional: true },
        codeRefOrganisme: { key: 'codeRefOrganisme', optional: true, default: '' },
        idDomaine: { key: 'idDomaine', optional: true },
        codeDomaine: { key: 'codeDomaine', optional: true, default: '' },
        idIntervenant: { key: 'idIntervenant', optional: true },
        mailIntervenant: { key: 'mailIntervenant', optional: true, default: '' },
        idPortail: { key: 'idPortail', optional: true },
        codePortail: { key: 'codePortail', optional: true, default: '' },
        utilisateurType: { key: 'utilisateurType', optional: true, default: UtilisateurTypeCode.NONE },
        roles: { key: 'roles', converter: new (ArrayClassConverterFactory.build(String))() }
    };

    token: string = undefined;
    idOrganisme: number = undefined;
    codeRefOrganisme: string = undefined;
    idDomaine: number = undefined;
    codeDomaine: string = undefined;
    idIntervenant: number = undefined;
    mailIntervenant: string = undefined;
    idPortail: number = undefined;
    codePortail: string = undefined;
    utilisateurType: UtilisateurTypeCode = UtilisateurTypeCode.NONE;
    roles: string[] = [];
}
